// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gif-drawer-ui .gif-scroll{overflow:hidden;width:100%}.gif-drawer-ui .gif-scroll .gif-scroll-inner{max-height:calc(100vh - 150px);overflow-y:auto;-ms-overflow-style:none;scrollbar-width:none}.gif-drawer-ui .gif-scroll .gif-scroll-inner::-webkit-scrollbar{display:none}.gif-drawer-ui .gif-scroll img{border-radius:10px;cursor:pointer;margin-bottom:8px;width:100%}.gif-drawer-ui .formulate-input{margin:0}.gif-drawer-ui .formulate-input[data-classification=text] input{background:transparent;border:none;box-shadow:none;font-size:1rem;height:100%;line-height:3rem;outline:none}.gif-drawer-ui .loader-wrapper-mobile{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%;z-index:50}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
